import React from "react"
import SearchIcon from "../images/icons/search.inline.svg"

const Search = ({ searchTitle, setSearchQuery }) => {
  return (
    <div className={`relative w-full sm:w-1/2 lg:w-96`}>
      <input
        name="query"
        onChange={e => setSearchQuery(e.target.value)}
        autoComplete="off"
        placeholder={searchTitle}
        className={`form-input block w-full text-xs h-12 border border-gray-silver text-black`}
      />
      <SearchIcon className="absolute w-5 h-4 right-3 top-4 " />
    </div>
  )
}

export default Search
